import { useState } from "react";
import { videos } from "../data/scenes";

export default function VideoViewer() {
  const [selectedVideo, setSelectedVideo] = useState(null);

  // Video Player
  if (selectedVideo) {
    return (
      <div
        style={{
          width: "100%",
          height: "100dvh",
          background: "#000",
          position: "relative",
        }}
      >
        <button
          onClick={() => setSelectedVideo(null)}
          style={{
            position: "absolute",
            top: 100,
            left: 20,
            zIndex: 10,
            padding: "10px 16px",
            border: "none",
            borderRadius: 8,
            cursor: "pointer",
          }}
        >
          ← Back
        </button>

        <video
          controls
          autoPlay
          playsInline
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        >
          <source src={selectedVideo.src} type="video/mp4" />
        </video>
      </div>
    );
  }

  // Video Selection Screen
  return (
    <div
      style={{
        width: "100%",
        height: "100dvh",
        background: "#000",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 30,
        flexWrap: "wrap",
        padding: 20,
      }}
    >
      {videos.map((video) => (
        <div
          key={video.id}
          onClick={() => setSelectedVideo(video)}
          style={{
            width: 320,
            cursor: "pointer",
            borderRadius: 12,
            overflow: "hidden",
            background: "#111",
            boxShadow: "0 4px 12px rgba(0,0,0,0.4)",
          }}
        >
          <img
            src={video.thumbnail}
            alt={video.title}
            style={{
              width: "100%",
              height: 180,
              objectFit: "cover",
            }}
          />

          <div
            style={{
              padding: 15,
              color: "#fff",
              textAlign: "center",
              fontWeight: 600,
            }}
          >
            {video.title}
          </div>
        </div>
      ))}
    </div>
  );
}